import React, { useContext, useEffect, useState } from 'react';

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

import DeviceHub from '@material-ui/icons/DeviceHub';

import {
  useHistory,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawerTechnical from '../../fields/menuDrawerTechnical';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getPrograms } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ListProgramsTechnical({ lang, handleChangeLang }) {
  const sessionContext = useContext(SessionContext);

  const [programsList, setProgramsList] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const getProgramsFromServer = async () => {
      setShowLoading(true);
      const response = await getPrograms(sessionContext.userToken);
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat
        setProgramsList(response.data.programs);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getProgramsFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render


  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();
  
  const gotoProgramConfiguration = (programId) => {
    history.push(`/technical/programConfiguration/${programId}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };


  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawerTechnical type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            {/* <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} /> */}
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_allPrograms']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={6}>
                <List component="nav">
                  {
                    programsList.map((program)=> (
                      <React.Fragment key={program._id}>
                        <ListItem button onClick={() => gotoProgramConfiguration(program._id)}>
                          <ListItemIcon>
                            <DeviceHub />
                          </ListItemIcon>
                          <ListItemText primary={program.name} secondary={program.sharedId} />
                        </ListItem>
                        <Divider />
                      </React.Fragment>
                    ))
                  }
                </List>              
              </Grid>
            </Grid>
          </Grid>        
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListProgramsTechnical);

// Indica i controla els props que se han de passar al component
ListProgramsTechnical.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};
